import { FC } from 'react';

export const RightColumn: FC = ({ children }) => {
    return <div className='w-full md:w-1/3 flex flex-col'>{children}</div>;
};
